var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-404"},[_c('div',{staticClass:"context-404"},[_vm._v("404")]),_c('el-button',{on:{"click":_vm.goBack}},[_vm._v("返回")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }